// ✅ US Market Software Development - Thin Wrapper (DRY principle)
import SoftwareDevelopmentPage from '../software-development';
import SEOHead from '../../components/SEOHead';

export default function USSoftwareDevelopment() {
  return (
    <>
      <SEOHead
        title='Software Development | US Market | LBVisible'
        description='Custom software development services for US businesses.'
        keywords='software development USA, custom software USA, enterprise software'
        canonicalUrl='/us/software-development'
        lang='en'
        hreflang={[
          { hreflang: 'en-GB', href: 'https://www.lbvisible.com/software-development' },
          { hreflang: 'en-US', href: 'https://www.lbvisible.com/us/software-development' },
          { hreflang: 'lt-LT', href: 'https://www.lbvisible.com/lt/svetainiu-programavimas' },
          { hreflang: 'x-default', href: 'https://www.lbvisible.com/software-development' },
        ]}
      />

      <SoftwareDevelopmentPage />
    </>
  );
}
